"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _core = require("@material-ui/core");
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _styles = require("@material-ui/styles");
var _formik = require("formik");
var _formFields = require("react-platform-components/dist/form-fields");
var _formValidators = require("react-platform-components/dist/form-validators");
var _Translations = require("react-platform-components/dist/Translations");
var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));
var _CustomSwitch = require("../components/CustomSwitch");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CategoryOfProductField = null;
try {
  CategoryOfProductField = require('react-platform-category-of-product/dist/CategoryOfProduct/CategoryOfProductField').default;
} catch (error) {
  console.log('errror categori of product');
}
var styles = function styles(theme) {
  return {
    iconContainer: {
      backgroundColor: theme.palette.primary.main,
      marginRight: 5,
      width: 35,
      height: 35
    },
    title: {
      marginTop: 30,
      marginBottom: 10
    }
  };
};

// note: for orders the specificities we must send orders to the props

// ** case 1: for order the specificities in one section
// [
//     {
//         "orders": [
//           "f9fbcd03-78e0-4ed0-9cce-eb65a37fdef7",
//           "68a254a2-f018-4e89-8d96-a1b0ea114512",
//           "58627bef-8146-43b5-bd99-7a04af8cf681"
//         ]
//     }
// ]
// ** case 2: for order the specificities in many sections
// [
//     {
//         "label": "Caractéristique téchnique",
//         "icon": "airport_shuttle",
//         "orders": [
//           "f9fbcd03-78e0-4ed0-9cce-eb65a37fdef7",
//           "68a254a2-f018-4e89-8d96-a1b0ea114512",
//           "58627bef-8146-43b5-bd99-7a04af8cf681"

//         ]
//     },
//     {
//         "label": "Vie à bord",
//         "icon": "hotel",
//         "orders": [
//             "f4fe4cc3-0997-4602-ad1e-ffa72d7b6bfc",
//             "384a3f0e-2079-422d-aa9c-f0580cd1c630"
//         ]
//     },

//     {
//         "label": "Autonomie",
//         "icon": "traffic",
//         "orders": [
//             "fc48f7b4-8e49-4244-ac4d-68e3591f4a13"
//         ]
//     },
//     {
//         "icon": "outdoor_grill",
//         "label": "Equipement",
//         "orders": []
//     }
// ]
var SpecificitiesOfProductFields = /*#__PURE__*/function (_React$Component) {
  _inherits(SpecificitiesOfProductFields, _React$Component);
  var _super = _createSuper(SpecificitiesOfProductFields);
  function SpecificitiesOfProductFields() {
    var _this;
    _classCallCheck(this, SpecificitiesOfProductFields);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "addSpecificities", function (nextValues) {
      var _this$props = _this.props,
        categories = _this$props.categories,
        values = _this$props.values,
        specificities = _this$props.specificities;
      // // Find selected category
      var selectedCategory = _lodash.default.find(categories, {
        id: _lodash.default.get(nextValues ? nextValues : values, 'category')
      });
      // Loop through deep_category_specificities param of the selected category
      // and add each category to the specificities form field
      _this.props.setFieldValue('specificities', selectedCategory.deep_category_specificities.map(function (item) {
        return _objectSpread(_objectSpread(_objectSpread({
          choice: null
        }, item), _lodash.default.find(_this.props.product.product_specificities, function (spec) {
          return spec.specificity.id === item.specificity.id;
        })), {}, {
          specificity: _lodash.default.find(specificities, {
            id: item.specificity.id
          })
        });
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderSpecificity", function (item) {
      var _values$specificities4;
      var values = _this.props.values;
      var specificity = item.specificity;
      var index = _lodash.default.findIndex(values.specificities, function (elm) {
        return elm.specificity.uuid === specificity.uuid;
      });
      var choices = _lodash.default.orderBy(item.specificity.choices, ['label'], ['asc']);
      return /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12,
        key: index
      }, specificity.type === 'list' ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        xs: 12,
        md: 12
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: !_lodash.default.isEmpty(specificity.description) ? 10 : 12,
        md: !_lodash.default.isEmpty(specificity.description) ? 11 : 12
      }, /*#__PURE__*/_react.default.createElement(_formFields.Select, {
        variant: "outlined",
        fullWidth: true,
        required: item.required,
        label: specificity.name,
        name: "specificities[".concat(index, "].choice"),
        margin: "normal",
        onChange: function onChange(event) {
          _this.props.setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
        },
        value: values.specificities[index].choice || '',
        validate: item.required ? (0, _formValidators.required)() : function () {}
      }, choices && choices.map(function (choice) {
        return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
          key: choice.value,
          value: choice.value
        }, choice.label);
      })), "  "), !_lodash.default.isEmpty(specificity.description) && /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 2,
        md: 1,
        style: {
          display: "flex"
        },
        justifyContent: "center",
        alignItems: "center"
      }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
        title: specificity === null || specificity === void 0 ? void 0 : specificity.description
      }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null)))) : specificity.type === 'date' ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        xs: 12,
        md: 12
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: !_lodash.default.isEmpty(specificity.description) ? 10 : 12,
        md: !_lodash.default.isEmpty(specificity.description) ? 11 : 12
      }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
        name: "specificities[".concat(index, "].choice"),
        value: values.specificities[index].choice || '',
        label: specificity.name,
        margin: "normal",
        variant: "outlined",
        fullWidth: true,
        type: "date",
        required: item.required,
        validate: item.required ? (0, _formValidators.required)() : function () {},
        onChange: function onChange(event) {
          _this.props.setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
        },
        InputLabelProps: {
          shrink: true
        }
      }), " "), !_lodash.default.isEmpty(specificity.description) && /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 2,
        md: 1,
        style: {
          display: "flex"
        },
        justifyContent: "center",
        alignItems: "center"
      }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
        title: specificity === null || specificity === void 0 ? void 0 : specificity.description
      }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null)))) : specificity.type === 'free' ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        xs: 12,
        md: 12
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: !_lodash.default.isEmpty(specificity.description) ? 10 : 12,
        md: !_lodash.default.isEmpty(specificity.description) ? 11 : 12
      }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
        name: "specificities[".concat(index, "].choice"),
        value: values.specificities[index].choice || '',
        label: specificity.name,
        margin: "normal",
        variant: "outlined",
        fullWidth: true,
        onChange: function onChange(event) {
          _this.props.setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
        },
        required: item.required,
        validate: item.required ? (0, _formValidators.required)() : function () {}
      })), !_lodash.default.isEmpty(specificity.description) && /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 2,
        md: 1,
        style: {
          display: "flex",
          marginLeft: "5px"
        },
        justifyContent: "center",
        alignItems: "center"
      }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
        title: specificity === null || specificity === void 0 ? void 0 : specificity.description
      }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null)))) : specificity.type === 'm_list' ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        xs: 12,
        md: 12
      }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: !_lodash.default.isEmpty(specificity.description) ? 10 : 12,
        md: !_lodash.default.isEmpty(specificity.description) ? 11 : 12
      }, /*#__PURE__*/_react.default.createElement(_formFields.Select, {
        variant: "outlined",
        fullWidth: true,
        margin: "normal",
        required: item.required,
        value: values.specificities[index].choice || [],
        label: specificity.name,
        name: "specificities[".concat(index, "].choice"),
        validate: item.required ? (0, _formValidators.required)() : function () {},
        onChange: function onChange(event) {
          _this.props.setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
        },
        renderValue: function renderValue(selectedValues) {
          return selectedValues.map(function (value) {
            var _choices$find;
            return choices === null || choices === void 0 ? void 0 : (_choices$find = choices.find(function (choice) {
              return choice.value === value;
            })) === null || _choices$find === void 0 ? void 0 : _choices$find.label;
          }).join(', ');
        },
        multiple: true
      }, choices && choices.map(function (_ref) {
        var _values$specificities, _values$specificities2, _values$specificities3;
        var label = _ref.label,
          value = _ref.value;
        return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
          key: value,
          value: value
        }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
          checked: !!((_values$specificities = values.specificities) !== null && _values$specificities !== void 0 && (_values$specificities2 = _values$specificities[index]) !== null && _values$specificities2 !== void 0 && (_values$specificities3 = _values$specificities2.choice) !== null && _values$specificities3 !== void 0 && _values$specificities3.includes(value))
        }), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
          primary: label
        }));
      })), "  "), !_lodash.default.isEmpty(specificity.description) && /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 2,
        md: 1,
        style: {
          display: "flex"
        },
        justifyContent: "center",
        alignItems: "center"
      }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
        title: specificity === null || specificity === void 0 ? void 0 : specificity.description
      }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null)))) : specificity.type === 'boolean' ? /*#__PURE__*/_react.default.createElement(_CustomSwitch.CustomSwitch, {
        label: specificity.name,
        description: specificity.description,
        checked: !!((_values$specificities4 = values.specificities[index]) !== null && _values$specificities4 !== void 0 && _values$specificities4.choice) || false,
        handleChange: function handleChange(event) {
          _this.props.setFieldValue("specificities.".concat(index, ".choice"), event.target.checked);
        },
        name: "specificities[".concat(index, "].choice")
      }) : null);
    });
    return _this;
  }
  _createClass(SpecificitiesOfProductFields, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (CategoryOfProductField) {
        var _categories$;
        var _this$props2 = this.props,
          categories = _this$props2.categories,
          values = _this$props2.values;
        // When the user selects a category we are get the specificities of selected category and display it
        if (categories && (_categories$ = categories[0]) !== null && _categories$ !== void 0 && _categories$.deep_category_specificities && _lodash.default.get(values, 'category') !== _lodash.default.get(nextProps.values, 'category')) {
          this.addSpecificities(nextProps.values);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (CategoryOfProductField) {
        var _categories$2;
        var _this$props3 = this.props,
          categories = _this$props3.categories,
          values = _this$props3.values,
          specificities = _this$props3.specificities,
          isEdit = _this$props3.isEdit;
        if (isEdit && categories && (_categories$2 = categories[0]) !== null && _categories$2 !== void 0 && _categories$2.deep_category_specificities && _lodash.default.get(values, 'category') && specificities && !_lodash.default.isEmpty(specificities) && _lodash.default.get(values, 'category') !== _lodash.default.get(prevProps.values, 'category') && _lodash.default.get(values, 'specificities') === _lodash.default.get(prevProps.values, 'specificities')) {
          this.addSpecificities();
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Handle the case when the field is used in a steps form, it needs to show up if
      // there is a category and no specificities
      if (CategoryOfProductField) {
        var _categories$3;
        var _this$props4 = this.props,
          categories = _this$props4.categories,
          values = _this$props4.values,
          specificities = _this$props4.specificities;
        if (categories && (_categories$3 = categories[0]) !== null && _categories$3 !== void 0 && _categories$3.deep_category_specificities && _lodash.default.get(values, 'category') && specificities && !_lodash.default.isEmpty(specificities) && _lodash.default.isEmpty(_lodash.default.get(values, 'specificities'))) {
          this.addSpecificities();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props5 = this.props,
        classes = _this$props5.classes,
        specificities = _this$props5.specificities,
        values = _this$props5.values,
        label = _this$props5.label,
        orders = _this$props5.orders;
      var defaultLabel = _lodash.default.isUndefined(label) ? "Specificities" : label;
      if (CategoryOfProductField) {
        if (!_lodash.default.get(values, 'category') || !values.specificities || _lodash.default.isEmpty(values.specificities)) {
          // hide this fieds if the category is not selected yet
          return null;
        }
        return /*#__PURE__*/_react.default.createElement(_core.Grid, {
          item: true,
          xs: 12,
          style: {
            marginTop: 35
          }
        }, /*#__PURE__*/_react.default.createElement(_formik.FieldArray, {
          name: "specificities",
          render: function render(arrayHelpers) {
            return /*#__PURE__*/_react.default.createElement(_core.Grid, {
              container: true,
              item: true,
              xs: 12,
              alignItems: "center"
            }, defaultLabel && /*#__PURE__*/_react.default.createElement(_core.Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
              variant: "subtitle1",
              className: "pl-2",
              style: {
                fontSize: '1.1rem',
                color: '#908f8f'
              }
            }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
              id: defaultLabel
            }))), !orders ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, specificities && specificities.length > 0 && values.specificities && values.specificities.map(function (item) {
              return _this2.renderSpecificity(item);
            })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !_lodash.default.isEmpty(specificities) && orders.map(function (value) {
              return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, value.label && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, value.icon && /*#__PURE__*/_react.default.createElement(_core.Avatar, {
                className: "".concat(classes.title, " ").concat(classes.iconContainer)
              }, /*#__PURE__*/_react.default.createElement(_Icon.default, null, value.icon)), /*#__PURE__*/_react.default.createElement(_core.Typography, {
                variant: "subtitle1",
                className: "pl-2 ".concat(classes.title),
                style: {
                  color: '#908f8f'
                }
              }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
                id: value.label
              }))), value.orders.map(function (uuid) {
                var item = _lodash.default.find((values === null || values === void 0 ? void 0 : values.specificities) || [], function (item) {
                  return item.specificity.uuid === uuid;
                });
                if (item) return _this2.renderSpecificity(item);
                return null;
              }));
            })));
          }
        }));
      } else {
        return /*#__PURE__*/_react.default.createElement(_core.Grid, {
          item: true,
          xs: 12,
          style: {
            marginTop: 35
          }
        }, /*#__PURE__*/_react.default.createElement(_formik.FieldArray, {
          name: "specificities",
          render: function render(arrayHelpers) {
            return /*#__PURE__*/_react.default.createElement(_core.Grid, {
              container: true,
              item: true,
              xs: 12,
              alignItems: "center"
            }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
              variant: "subtitle1",
              className: "pl-2",
              style: {
                fontSize: '1.1rem',
                color: '#908f8f'
              }
            }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
              id: "Specificities"
            }))), specificities && specificities.length > 0 && specificities.map(function (specificity, index) {
              // const specificity = specificities.filter(option => Number(option.id) === Number(item.specificity.id))[0]
              var choices = _lodash.default.orderBy(specificity.specificity.choices, ['label'], ['asc']);
              return /*#__PURE__*/_react.default.createElement(_core.Grid, {
                item: true,
                xs: 12,
                key: index
              }, specificity.type === 'list' ? /*#__PURE__*/_react.default.createElement(_formFields.Select, {
                variant: "outlined",
                fullWidth: true,
                required: true,
                validate: (0, _formValidators.required)(),
                label: specificity.name,
                name: "specificities[".concat(index, "].choice"),
                margin: "normal",
                value: _lodash.default.get(values, "specificities[".concat(index, "].choice")) || '',
                onChange: function onChange(event) {
                  _this2.props.setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
                  _this2.props.setFieldValue("specificities.".concat(index, ".specificity.id"), specificity.id);
                  _this2.props.setFieldValue("specificities.".concat(index, ".type"), specificity.type);
                }
              }, choices && choices.map(function (choice) {
                return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
                  key: choice.value,
                  value: choice.value
                }, choice.label);
              })) : specificity.type === 'date' ? /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
                name: "specificities[".concat(index, "].choice"),
                value: _lodash.default.get(values, "specificities[".concat(index, "].choice")) || '',
                label: specificity.name,
                margin: "normal",
                variant: "outlined",
                fullWidth: true,
                type: "date",
                required: true,
                validate: (0, _formValidators.required)(),
                onChange: function onChange(event) {
                  _this2.props.setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
                  _this2.props.setFieldValue("specificities.".concat(index, ".specificity.id"), specificity.id);
                  _this2.props.setFieldValue("specificities.".concat(index, ".type"), specificity.type);
                },
                InputLabelProps: {
                  shrink: true
                }
              }) : specificity.type === 'free' ? /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
                name: specificity.name,
                value: _lodash.default.get(values, "specificities[".concat(index, "].choice")) || '',
                label: "specificities[".concat(index, "].choice"),
                margin: "normal",
                variant: "outlined",
                fullWidth: true,
                onChange: function onChange(event) {
                  _this2.props.setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
                  _this2.props.setFieldValue("specificities.".concat(index, ".specificity.id"), specificity.id);
                  _this2.props.setFieldValue("specificities.".concat(index, ".type"), specificity.type);
                },
                required: true,
                validate: (0, _formValidators.required)()
              }) : specificity.type === 'm_list' ? /*#__PURE__*/_react.default.createElement(_formFields.Select, {
                variant: "outlined",
                fullWidth: true,
                margin: "normal",
                required: true,
                value: _lodash.default.get(values, "specificities[".concat(index, "].choice")) || [],
                label: specificity.name,
                name: "specificities[".concat(index, "].choice"),
                validate: (0, _formValidators.required)(),
                onChange: function onChange(event) {
                  _this2.props.setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
                  _this2.props.setFieldValue("specificities.".concat(index, ".specificity.id"), specificity.id);
                  _this2.props.setFieldValue("specificities.".concat(index, ".type"), specificity.type);
                },
                renderValue: function renderValue(selectedValues) {
                  return selectedValues.map(function (value) {
                    var _choices$find2;
                    return choices === null || choices === void 0 ? void 0 : (_choices$find2 = choices.find(function (choice) {
                      return choice.value === value;
                    })) === null || _choices$find2 === void 0 ? void 0 : _choices$find2.label;
                  }).join(', ');
                },
                multiple: true
              }, choices && choices.map(function (_ref2) {
                var _values$specificities5, _values$specificities6;
                var label = _ref2.label,
                  value = _ref2.value;
                return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
                  key: value,
                  value: value
                }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
                  checked: !!((_values$specificities5 = values.specificities[index]) !== null && _values$specificities5 !== void 0 && (_values$specificities6 = _values$specificities5.choice) !== null && _values$specificities6 !== void 0 && _values$specificities6.includes(value))
                }), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
                  primary: label
                }));
              })) : specificity.type === 'boolean' ? /*#__PURE__*/_react.default.createElement(_CustomSwitch.CustomSwitch, {
                label: specificity.name,
                description: specificity.description,
                checked: _lodash.default.get(values, "specificities[".concat(index, "].choice")) || false,
                handleChange: function handleChange(event) {
                  _this2.props.setFieldValue("specificities.".concat(index, ".choice"), event.target.checked);
                  _this2.props.setFieldValue("specificities.".concat(index, ".specificity.id"), specificity.id);
                  _this2.props.setFieldValue("specificities.".concat(index, ".type"), specificity.type);
                },
                name: "specificities[".concat(index, "].choice")
              }) : null);
            }));
          }
        }));
      }
    }
  }]);
  return SpecificitiesOfProductFields;
}(_react.default.Component);
var _default = (0, _styles.withStyles)(styles)((0, _reactRedux.connect)(function (state) {
  return {
    categories: state.categoryOfProductReducer ? state.categoryOfProductReducer.categories : null,
    specificities: state.specificityOfProductReducer.specificities
  };
})(SpecificitiesOfProductFields));
exports.default = _default;